/* eslint-disable indent */
import React from 'react';
import { Select, Radio, Empty } from 'antd';
import {
  CaretDownOutlined,
  CaretUpOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
const { Option } = Select;
import './SelectRadio.scss';

const DropdownRadioGroup = ({ options, value, onChange }) => {
  const hasOptions = options && options.length > 0;
  return hasOptions ? (
    <Radio.Group
      className='custom-select-radio'
      onChange={(e) => onChange?.(e.target.value)}
      style={{ display: 'flex', flexDirection: 'column', padding: 8 }}
      value={value}
    >
      {options.map((opt) => (
        <Radio key={opt.value} style={{ padding: '4px 0' }} value={opt.value}>
          {opt.label}
        </Radio>
      ))}
    </Radio.Group>
  ) : (
    <div
      style={{
        padding: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Empty description='No Data' />
    </div>
  );
};
const SelectRadio = ({
  options,
  label,
  value,
  onChange,
  onClear,
  onClick,
  ...rest
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const hasOptions = options && options.length > 0;
  const handleChange = (selectedValue) => {
    setIsOpen(false);
    onChange(selectedValue ?? '');
  };
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <Select
        allowClear={
          value
            ? {
                clearIcon: (
                  <CloseCircleOutlined className='text-lg text-primary-600' />
                ),
              }
            : false
        }
        className='custom-select-radio'
        dropdownRender={() => (
          <DropdownRadioGroup
            onChange={handleChange}
            options={options}
            value={value}
          />
        )}
        onChange={handleChange}
        onClear={() => {
          onClear?.();
          setIsOpen(false);
        }}
        onClick={onClick}
        onDropdownVisibleChange={setIsOpen}
        open={isOpen}
        style={{ width: '100%' }}
        suffixIcon={isOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}
        value={value}
        {...rest}
      >
        {hasOptions &&
          options.map((opt) => (
            <Option key={opt.id} value={opt.value}>
              {opt.label}
            </Option>
          ))}
      </Select>
      {label && !value && (
        <span
          style={{
            position: 'absolute',
            top: '50%',
            left: '11px',
            fontSize: '0.875rem',
            color: '#999',
            backgroundColor: 'transparent',
            padding: '0 4px',
            zIndex: 1,
            pointerEvents: 'none',
            transform: 'translateY(-50%)',
          }}
        >
          {label}
        </span>
      )}
    </div>
  );
};

export default SelectRadio;
